



















































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Decisions from '@/store/modules/Decisions';
import Scoring from '@/store/modules/Scoring';

const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);

@Component({
    components: {},
})
export default class UiSettingMenu extends Vue {

    private menu = false;

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || {};
    }

    get autoCalc() {
        return workspaceOptionsModule.autoCalc;
    }

    set autoCalc(calculate: boolean) {
        if(calculate){
            scoringModule.recalculateAllChoiceScores(this.activeViewpointId);
        }
        workspaceOptionsModule.setAutoCalc(calculate);
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    set scoreBarVisibility(visible: boolean) {
        workspaceOptionsModule.changeScoreBarVisibility(visible);
    }

    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    set descriptionVisibility(visible: boolean) {
        workspaceOptionsModule.changeDescriptionVisibility(visible);
    }

    get skipGroups() {
        return workspaceOptionsModule.skipGroups;
    }

    set skipGroups(val: boolean) {
        workspaceOptionsModule.changeSkipGroups(val);
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId || '';
    }

    get activeFactorLists() {
        return workspaceOptionsModule.activeFactorLists || [];
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    set showNonListFactors(val: boolean) {
        workspaceOptionsModule.setShowNonListFactors(val);
    }

    get trimTopGroups() {
        return workspaceOptionsModule.trimTopGroups;
    }

    set trimTopGroups(val: boolean) {
        workspaceOptionsModule.changeTrimTopGroups(val);
    }

    get scoresVisibility() {
        return workspaceOptionsModule.scoresVisibility;
    }

    set scoresVisibility(val: boolean) {
        workspaceOptionsModule.setScoresVisibility(val);
    }

    get keysVisibility() {
        return workspaceOptionsModule.keysVisibility;
    }

    set keysVisibility(val: boolean) {
        workspaceOptionsModule.setKeysVisibility(val);
    }

    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility;
    }

    set commentsVisibility(val: boolean) {
        workspaceOptionsModule.setCommentsVisibility(val);
    }

    get iconScoring() {
        return workspaceOptionsModule.showIconScoring;
    }

    set iconScoring(visible: boolean) {
        workspaceOptionsModule.changeIconScoring(visible);
    }

    get customRangeActive() {
        return workspaceOptionsModule.customRangeActive;
    }

    set customRangeActive(visible: boolean) {
        workspaceOptionsModule.changeCustomRangeActive(visible);
    }

    get denominatorScoring() {
        return workspaceOptionsModule.denominatorScoring;
    }

    set denominatorScoring(visible: boolean) {
        workspaceOptionsModule.changeDenominatorScoring(visible);
    }

    get standardizeDenominator() {
        return workspaceOptionsModule.standardizeDenominator;
    }

    set standardizeDenominator(visible: boolean) {
        workspaceOptionsModule.changeStandardizeDenominator(visible);
    }

    get showFactorData() {
        return workspaceOptionsModule.showFactorData;
    }

    set showFactorData(visible: boolean) {
        workspaceOptionsModule.changeShowFactorData(visible);
    }


}
